/**
 * Navigation Component Exports
 *
 * @since 1.0.0
 */

export { Navigation } from './component';
